import { USERS_ROUTES } from '../../constants/_routes'
import { formatRoute } from 'react-router-named-routes'
import usersTypes from '../../constants/usersTypes'
import { axios, reset_axios } from '../../services'
import store from '../../store'

const delete_user_request = () => {
  return {
    type: usersTypes.delete.request
  }
}

const delete_user_success = (response) => {
  return {
    type: usersTypes.delete.success
  }
}

const delete_user_failure = (messages) => {
  return {
    type: usersTypes.delete.failure,
    payload: messages
  }
}

const destroy_user_storage = () => {
  localStorage.removeItem('userdata')
  reset_axios()
}

// const logout_success = () => {
//   return {
//     type: auth_types.LOGOUT.success
//   }
// }
//
const clear_state = () => {
  return {
    type: "CLEAR_APP_STATE"
  }
}

const delete_user = (user_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(delete_user_request())

    // Request
    axios.delete(
      formatRoute(USERS_ROUTES.get, {id: user_id})
    ).then( response => {
      // success
      destroy_user_storage()
      // dispatch( logout_success( ) )
      dispatch( delete_user_success(response) )
      dispatch( clear_state( ) )
      window.showSnackbar( 'success', "Your account has been permanently deleted." )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error deleting account."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( delete_user_failure(errors))
    })
  }

}

export {
  delete_user
}



// WEBPACK FOOTER //
// ./src/js/actions/users/delete.js